import axios from "@/util/axios";
export default {
  permissions: () => axios.get("/api/user/permissions"),
  getPhone: (code, token) =>axios.post("/api/user/user_phone", { code, token }),
  jsTicket: (code, url) => axios.post("/api/user/js_ticket", { code, url }),
  authBaseInfo: () => axios.post("/api/user/auth_base_info", {}),
  meetingObjId: (meetingId) => axios.post("api/user/meeting_info", { meetingId }),
};
